import { SET_CURRENT_USER } from "./type";

export const setCurrentUser = (user) => {
  return {
    type: SET_CURRENT_USER,
    user: user,
  };
};
